import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitooutstationcabs() {



const cardData = {
  keyword: "Mumbai to Outstation Cabs",
  heading: "Lotus Cab: Mumbai to Outstation Cab Service",

  headingDescription:
    "Lotus Cab offers professional and reliable Mumbai to Outstation Cab services for travelers seeking comfortable intercity journeys across Maharashtra and Pan India destinations. Whether you need a one-way drop, round trip taxi, family vacation vehicle, or corporate outstation transport, we provide clean AC sedans, SUVs, luxury cars, and mini buses driven by experienced chauffeurs. Our service is ideal for weekend trips, business travel, religious tours, hill station visits, and long-distance journeys. Transparent per-kilometer pricing, fixed packages, and flexible scheduling options ensure complete convenience. All vehicles are regularly maintained and sanitized for safety and hygiene. With 24/7 booking support and punctual pickup from any Mumbai location, Lotus Cab guarantees a smooth, safe, and stress-free outstation travel experience.",

  top: "Popular Outstation Destinations from Mumbai",

  topPlaces: [
    {
      title: "Pune",
      description:
        "Pune is one of the most frequently traveled routes from Mumbai for business and leisure. The Mumbai-Pune Expressway offers a smooth highway journey. Sedan and SUV options are ideal for comfortable travel. One-way and round-trip options available. Perfect for same-day return or weekend trips. Lotus Cab ensures safe and timely intercity transfers."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a popular hill station for short weekend trips. Scenic ghats require experienced drivers. SUV vehicles are recommended for comfort. Ideal for family and group travel. Lotus Cab offers flexible packages."
    },
    {
      title: "Shirdi",
      description:
        "Shirdi is a major religious destination visited by thousands of devotees. Comfortable AC cab travel ensures relaxed darshan trips. Same-day return options available. Professional drivers ensure safe long-distance travel."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a scenic hill station known for cool climate and viewpoints. Long-distance comfort is essential for this route. SUV and luxury vehicles enhance travel experience."
    },
    {
      title: "Nashik",
      description:
        "Nashik is famous for temples and vineyards. Outstation cabs provide smooth and comfortable travel. Ideal for religious and leisure trips."
    },
    {
      title: "Goa",
      description:
        "Goa is a popular beach destination requiring long-distance travel. Luxury and SUV vehicles recommended for comfort. Lotus Cab ensures safe overnight and extended travel."
    }
  ],

  services: [
    {
      name: "Mumbai to Outstation Cab",
      description:
        "Reliable outstation cab service from Mumbai to major cities and tourist destinations. Clean AC vehicles with experienced drivers ensure comfortable long-distance travel. Flexible one-way and round-trip options available. Transparent pricing structure maintained. Suitable for family vacations and corporate trips. 24/7 customer support provided."
    },
    {
      name: "One Way Cab Mumbai to Outstation",
      description:
        "Affordable one-way cab service for drop-only travel from Mumbai. Ideal for airport transfers, relocation, and business travel. Pay only for one side of the journey. Professional chauffeurs ensure safe highway travel. Budget-friendly option for solo and family travelers."
    },
    {
      name: "Round Trip Cab Mumbai to Outstation",
      description:
        "Round-trip taxi packages for weekend and holiday travel. Flexible return schedule provided. Ideal for multi-day trips. Comfortable vehicles for long-distance journeys. Transparent billing with no hidden charges."
    },
    {
      name: "AC Sedan Cab Mumbai to Outstation",
      description:
        "Economical sedan vehicles perfect for small families and business travelers. Excellent mileage and comfortable interiors. Suitable for smooth highway journeys. Affordable per-kilometer rates available."
    },
    {
      name: "SUV Cab Mumbai to Outstation",
      description:
        "Spacious SUV taxis ideal for group travel and extra luggage needs. Comfortable seating and powerful highway performance. Recommended for hill station and long-distance routes."
    },
    {
      name: "Luxury Cab Mumbai to Outstation",
      description:
        "Premium luxury vehicles for executive and VIP travel. Superior comfort and professional chauffeur service. Ideal for corporate and special occasion travel."
    },
    {
      name: "Mini Bus Cab Mumbai to Outstation",
      description:
        "Mini bus options available for group tours and corporate outings. Comfortable seating capacity with luggage space. Ideal for school trips and family functions."
    },
    {
      name: "Online Booking Mumbai to Outstation",
      description:
        "Instant online booking facility with quick confirmation. Transparent fare estimates provided. 24/7 support for travel coordination."
    }
  ],

  tableData: [
    ["Mumbai to Outstation Cab", "One Way Cab Mumbai to Outstation"],
    ["Round Trip Cab Mumbai to Outstation", "AC Cab Mumbai to Outstation"],
    ["Sedan Cab Mumbai to Outstation", "SUV Cab Mumbai to Outstation"],
    ["Luxury Cab Mumbai to Outstation", "Family Trip Cab Mumbai to Outstation"],
    ["Corporate Cab Mumbai to Outstation", "Weekend Trip Cab Mumbai to Outstation"],
    ["Mini Bus Cab Mumbai to Outstation", "Online Booking Mumbai to Outstation"],
    ["Chauffeur Driven Cab Mumbai to Outstation", "Per Km Rate Cab Mumbai to Outstation"],
    ["Picnic Trip Cab Mumbai to Outstation", "Same Day Return Cab Mumbai to Outstation"],
    ["Budget Cab Mumbai to Outstation", "Best Cab Service Mumbai to Outstation"],
    ["Group Tour Cab Mumbai to Outstation", "Mumbai to Nearby City Cab"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Pan India Coverage",
      WhyChoosedescription:
        "Travel from Mumbai to any major city with safe and reliable intercity cab services."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per-kilometer and package rates with no hidden charges."
    },
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription:
        "Skilled chauffeurs ensure smooth and safe long-distance travel."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury cars, and mini buses available."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way, round-trip, and multi-day packages available."
    },
    {
      WhyChooseheading: "Clean & Sanitized Fleet",
      WhyChoosedescription:
        "Vehicles regularly cleaned and maintained for hygiene."
    },
    {
      WhyChooseheading: "Corporate Travel Solutions",
      WhyChoosedescription:
        "Billing support and professional service for business clients."
    },
    {
      WhyChooseheading: "24/7 Customer Assistance",
      WhyChoosedescription:
        "Round-the-clock booking and support team available."
    }
  ]
};

const faqData = [
  { question: "Do you provide one-way outstation service?", answer: "Yes, affordable one-way cab service is available from Mumbai." },
  { question: "Is round-trip booking available?", answer: "Yes, flexible round-trip and multi-day packages are available." },
  { question: "Are SUV vehicles available?", answer: "Yes, spacious SUV taxis are available for group travel." },
  { question: "Is online booking supported?", answer: "Yes, instant booking confirmation is available online." },
  { question: "Are drivers experienced for highway travel?", answer: "Yes, trained and experienced chauffeurs handle long-distance routes." },
  { question: "Is pricing per km transparent?", answer: "Yes, clear pricing shared before confirmation." },
  { question: "Do you provide mini bus options?", answer: "Yes, mini buses available for group tours and corporate trips." },
  { question: "Is corporate billing supported?", answer: "Yes, invoice and billing support available for companies." },
  { question: "Is same-day return possible?", answer: "Yes, depending on route and schedule." },
  { question: "Is 24/7 service available?", answer: "Yes, round-the-clock outstation cab service provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback:
      "Booked Mumbai to Pune outstation cab. Smooth highway travel and professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Reliable outstation service for business travel. Transparent pricing and punctual pickup.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Ritu Sharma",
    feedback:
      "Comfortable SUV for family trip to Mahabaleshwar. Highly recommended.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Nikhil Patil",
    feedback:
      "Easy online booking and stress-free outstation journey.",
    rating: 5
  }
];

































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Outstation Cabs",
  "image": "https://lotuscab.com/assets/images/mumbai-outstation-cab.jpg", 
  "description": "Lotus Cab provides reliable Mumbai to Outstation cab services including AC, sedan, SUV, luxury cabs, and Mini Bus options. Perfect for one-way trips, round trips, family travel, corporate transfers, weekend trips, same-day returns, and chauffeur-driven rides. Book online with competitive per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "950"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-to-outstation-cabs"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Mumbai to Outstation Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Outstation cabs with Lotus Cab. AC, sedan, SUV, luxury cabs & Mini Bus for one-way, round trips, family trips, corporate transfers, weekend travel, same-day returns. Online booking available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Outstation Cab, Mumbai to Nearby City Cab, One Way Cab Mumbai to Outstation, Round Trip Cab Mumbai to Outstation, AC Cab Mumbai to Outstation, Sedan Cab Mumbai to Outstation, SUV Cab Mumbai to Outstation, Luxury Cab Mumbai to Outstation, Family Trip Cab Mumbai to Outstation, Corporate Cab Mumbai to Outstation, Weekend Trip Cab Mumbai to Outstation, Mini Bus Cab Mumbai to Outstation, Online Booking Mumbai to Outstation, Chauffeur Driven Cab Mumbai to Outstation, Per Km Rate Cab Mumbai to Outstation, Picnic Trip Cab Mumbai to Outstation, Same Day Return Cab Mumbai to Outstation, Budget Cab Mumbai to Outstation, Best Cab Service Mumbai to Outstation, Group Tour Cab Mumbai to Outstation" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitooutstationcabs;